module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-700-61afb09c05c72bf28ab5be4d2908f270.woff2";